import { Component } from "@angular/core";
import { StorageService } from "../../routes/services/storage.service";

@Component({
  selector: "app-free-nas-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"]
})
export class FreeNasLayoutComponent {
  constructor(public storageService: StorageService) {}
}
